import { api } from '@/lib/api'
import { API_PATHS } from '@/constants/api-paths'
import type { ApiResponse, EventTag } from '@/types'

export const eventTagsApi = {
  list: async (): Promise<EventTag[]> => {
    const response = await api.get<ApiResponse<EventTag[]>>(API_PATHS.jobs.eventTags.list)
    return response.data.data ?? []
  },

  create: async (payload: { title: string; code?: string }): Promise<EventTag> => {
    const response = await api.post<ApiResponse<EventTag>>(API_PATHS.jobs.eventTags.create, payload)
    return response.data.data
  },
}

export default eventTagsApi
